import { compose, isEmpty, symmetricDifference } from 'ramda';

/**
 * Compares two sets for equality ignoring the order.
 *
 * @param {[*]} set1
 * @param {[*]} set2
 * @returns {Boolean} sets contain equal items
 */
const equalsIgnoreOrder = compose(isEmpty, symmetricDifference);

export default equalsIgnoreOrder;
